module.exports = __webpack_public_path__ + "img/approve-list2.d2fcfecd.png";